// extracted by mini-css-extract-plugin
export default {"dark":"_2522M","light":"_16FGt"};